<template>
  <div class="mod-sale-shipping-notice">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="通知单号">
        <el-input v-model="dataForm.noticeCode" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="销售单号">
        <el-input v-model="dataForm.salesOrderCode" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="客户">
        <el-input v-model="dataForm.customerName" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="审核">
        <el-select v-model="dataForm.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" />
          <el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salesShippingNotice:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salesShippingNotice:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      @row-dblclick="rowDblclickHandle"
    >
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="noticeCode" label="通知单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('sale:salesShippingNotice:info')" class="code-link" @click="addOrUpdateHandle(scope.row.noticeId, true)">{{ scope.row.noticeCode }}</a>
          <span v-else>{{ scope.row.noticeCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="noticeDate" label="通知日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.noticeDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="salesOrderCode" label="销售单号" min-width="130" header-align="center" align="left" />
      <el-table-column prop="customerName" label="客户" min-width="130" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="totalQuantity" label="通知数量" width="100" header-align="center" align="left" />
      <el-table-column prop="logisticsCompany" label="物流公司" min-width="110" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="logisticsNo" label="物流单号" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="approveStatus" label="审核" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审</el-tag>
          <el-tag v-else type="info" size="small">未审</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" />
  </div>
</template>

<script>
import AddOrUpdate from './salesShippingNotice-add-or-update'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'SalesShippingNotice',
  components: { AddOrUpdate },
  data() {
    return {
      dataForm: { noticeCode: '', salesOrderCode: '', customerName: '', approveStatus: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      permCodes: []
    }
  },
  created() {
    this.loadPerms()
    this.getDataList()
  },
  activated() {
    this.getDataList()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    getDataList() {
      this.dataListLoading = true
      request.post('/sale/salesShippingNotice/list', {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        noticeCode: this.dataForm.noticeCode,
        code: this.dataForm.noticeCode,
        salesOrderCode: this.dataForm.salesOrderCode,
        customerName: this.dataForm.customerName,
        partnerName: this.dataForm.customerName,
        approveStatus: this.dataForm.approveStatus,
        status: this.dataForm.approveStatus
      }).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {}).finally(() => { this.dataListLoading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, readonly)
      })
    },
    open(id, readonly) {
      this.addOrUpdateHandle(id, !!readonly)
    },
    rowDblclickHandle(row) {
      if (!row || !row.noticeId || !this.isAuth('sale:salesShippingNotice:info')) return
      this.addOrUpdateHandle(row.noticeId, true)
    }
  }
}
</script>

<style scoped>
.code-link { color: #2563eb; cursor: pointer; }
</style>
